import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loader from "../assets/loader.json";
import { useSingletransctionhistoryMutation } from "../redux/features/user/userApi";
import { useChangeModeMutation } from "../redux/features/user/userApi";
import Navbar from "../Components/Navbar";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useRef } from "react";

const Singletransction = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [singletransctionhistory, { isSuccess, isError, isLoading, data }] = useSingletransctionhistoryMutation();
  const [transaction, setTransaction] = useState(null);
  const detailsRef = useRef();
  const [changeMode, { isLoading: isModeChanging }] = useChangeModeMutation();
  const [mode, setMode] = useState("");

  // Check permission for editing mode
  const canEditMode = (() => {
    const role = localStorage.getItem('role');
    if (role === 'admin') return true;
    try {
      const permission = JSON.parse(localStorage.getItem('permission'));
      return permission?.transaction_history?.write === true;
    } catch {
      return false;
    }
  })();

  useEffect(() => {
    if (id) {
      singletransctionhistory(id);
    }
  }, [id, singletransctionhistory]);

  useEffect(() => {
    if (isSuccess && data?.data) {
      setTransaction(data.data);
    }
  }, [isSuccess, data]);

  useEffect(() => {
    if (transaction?.mode) setMode(transaction.mode);
  }, [transaction]);

  const handleModeChange = async (e) => {
    const newMode = e.target.value;
    
      console.log(`newMode----42-----,Singletransction------>`,newMode); 
    
    setMode(newMode);
    try {
      await changeMode({ id: transaction._id, mode: newMode }).unwrap();
      setTransaction((prev) => ({ ...prev, mode: newMode }));
    } catch (err) {
      // Optionally show error
      setMode(transaction.mode); // revert
    }
  };

  // Format date function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  // Handle back navigation
  const handleBack = () => {
    navigate('/transaction');
  };

  // Handle explorer link
  const handleExplorerClick = (url) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  // Handle PDF download
  const handleDownloadPDF = async () => {
    const input = detailsRef.current;
    if (!input) return;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`transaction_${transaction.hash}.pdf`);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="flex items-center justify-center h-96">
          <div className="w-32 h-32">
            <Lottie animationData={loader} loop={true} />
          </div>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Transaction</h2>
            <p className="text-gray-600 mb-4">Transaction not found or error occurred.</p>
            <button
              onClick={handleBack}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
            >
              Back to Transactions
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!transaction) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-600 mb-4">Transaction Not Found</h2>
            <button
              onClick={handleBack}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors"
            >
              Back to Transactions
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-6">
            <button
              onClick={handleBack}
              className="inline-flex items-center text-indigo-600 hover:text-indigo-800 mb-4 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
              </svg>
              Back to Transactions
            </button>
            <h1 className="text-3xl font-bold text-gray-800 select-text">Transaction Details</h1>
            <p className="text-gray-600 mt-2 select-text">Transaction ID: {transaction._id}</p>
          </div>

          {/* Main Content */}
          <div ref={detailsRef} className="bg-white rounded-lg shadow-md overflow-hidden select-text">
            {/* Transaction Status Header */}
            <div className="px-6 py-4 bg-gradient-to-r from-indigo-500 to-purple-600">
              <div className="flex items-center justify-between">
                <div>
                  <h2 className="text-xl font-semibold text-white select-text">
                    {transaction.amount} {transaction.currency}
                  </h2>
                  <p className="text-indigo-100 text-sm select-text">
                    {transaction.ordertype === 'receive' ? 'Received' : 'Sent'} • {transaction.network}
                  </p>
                </div>
                <div className="text-right">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${transaction.status === 1
                    ? 'bg-green-100 text-green-800'
                    : 'bg-red-100 text-red-800'
                    } select-text`}>
                    {transaction.status === 1 ? 'Completed' : 'Failed'}
                  </span>
                </div>
              </div>
            </div>

            {/* Transaction Details */}
            <div className="p-6 select-text">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Column */}
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 select-text">Basic Information</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Email:</span>
                        <span className="text-gray-900 select-text">{transaction.email}</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Amount:</span>
                        <span className="text-gray-900 font-semibold select-text">
                          {transaction.amount} {transaction.currency}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">TokenID:</span>
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 select-text">
                          {transaction.tokenID}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Order Type:</span>
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${transaction.ordertype === 'receive'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-orange-100 text-orange-800'
                          } select-text`}>
                          {transaction.ordertype}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Mode:</span>
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${mode === "Sale"
                          ? 'bg-green-100 text-green-800'
                          : 'bg-orange-100 text-orange-800'
                          } select-text`}>
                          {/* Dropdown for admin to change mode */}
                          <select
                            value={mode}
                            onChange={handleModeChange}
                            className="bg-transparent outline-none text-xs font-medium"
                            disabled={!canEditMode || isModeChanging}
                          >
                            <option value="Sale">Sale</option>
                            <option value="Transfer">Transfer</option>
                            <option value="Free">Free</option>
                          </select>
                          {isModeChanging && <span className="ml-2 text-xs text-gray-400">Saving...</span>}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Network:</span>
                        <span className="text-gray-900 capitalize select-text">{transaction.network}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column */}
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 select-text">Transaction Details</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Description:</span>
                        <span className="text-gray-900 text-sm select-text">{transaction.description}</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Date:</span>
                        <span className="text-gray-900 text-sm select-text">{formatDate(transaction.date)}</span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Gas Fee:</span>
                        <span className="text-gray-900 select-text">
                          {transaction.GasFee || 'N/A'}
                        </span>
                      </div>
                      <div className="flex justify-between items-center py-2 border-b border-gray-100">
                        <span className="text-gray-600 font-medium select-text">Transaction Hash:</span>
                        <span className="text-gray-900 text-xs font-mono break-all select-text">
                          {transaction.hash || 'N/A'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Addresses Section */}
              <div className="mt-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4 select-text">Addresses</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-gray-50 p-4 rounded-lg select-text">
                    <h4 className="text-sm font-medium text-gray-600 mb-2 select-text">Sender Address</h4>
                    <p className="text-sm font-mono break-all text-gray-900 select-text">
                      {transaction.sendaddress || 'N/A'}
                    </p>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg select-text">
                    <h4 className="text-sm font-medium text-gray-600 mb-2 select-text">Receiver Address</h4>
                    <p className="text-sm font-mono break-all text-gray-900 select-text">
                      {transaction.receiveaddress || 'N/A'}
                    </p>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="mt-8 flex flex-wrap gap-4">
                {transaction.explorer && (
                  <button
                    onClick={() => handleExplorerClick(transaction.explorer)}
                    className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                  >
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path>
                    </svg>
                    View on Explorer
                  </button>
                )}
                <button
                  onClick={handleDownloadPDF}
                  className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                  </svg>
                  Download as PDF
                </button>
                <button
                  onClick={handleBack}
                  className="inline-flex items-center px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
                  </svg>
                  Back to List
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Singletransction;
